import React, {useCallback, useState} from 'react';
import {Container, Link, Stack, styled, Typography} from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CookieIcon from '@mui/icons-material/Cookie';
import {disableCookiesConsent, enableCookiesConsent, useCookiesConsent} from '../util/cookies.js';
import SCButton from './SCButton.js';
import { useOnce } from '../util/react_hooks.js';
import storage from '../util/storage.js';

const CookiesDisclaimerContainer = styled(Stack)`
    background-color: ${p=>p.theme.palette.background.paper};
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.1);
    z-index: 99999;
`;

const CookiesDisclaimer = ()=>{
    let cookiesConsent = useCookiesConsent();
    let [closed, setClosed] = useState(true);
    let enableConsent = useCallback(()=>{
        setClosed(true);
        enableCookiesConsent();
    }, []);
    let disableConsent = useCallback(()=>{
        setClosed(true);
        disableCookiesConsent();
    }, []);
    useOnce(()=>{
        let hide = storage.getBool('sc_hide_cookies_disclaimer');
        if (!hide)
            setClosed(false);
    });
    if (cookiesConsent||closed)
        return null;
    return <CookiesDisclaimerContainer>
      <Container maxWidth="lg">
        <Stack direction="row" gap={2} marginTop={4} marginBottom={4} alignItems="start">
          <CookieIcon fontSize="large"/>
          <Stack direction="column" gap={2} flexGrow={1}>
            <Typography>
              האתר עושה שימוש בקובצי  cookies, לרבות קובצי cookies של צד שלישי, עבור שיפור הפונקצינליות וחוויית הגלישה.<br/>
              המשך גלישה באתר זה מבלי לשנות את הגדרת קובצי ה-cookies של הדפדפן, מהווה אישור לשימוש שלנו בקובצי cookies.<br/>
              <Link href="/privacy-policy">לצפייה במדיניות הפרטיות</Link>
            </Typography>
            <Stack direction="row" gap={2} justifyContent="start">
              <SCButton text="מסכימ.ה" onClick={enableConsent} variant="contained" size="small"/>
              <SCButton text="לא מסכימ.ה" onClick={disableConsent} variant="outlined" size="small"/>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </CookiesDisclaimerContainer>;
};

export default CookiesDisclaimer;
